import { select } from '../helpers';

export default () => {
  const classRegistrationButton = select(
    '.field--name-field-class-registration a, .field--name-field-meeting-reg-link a',
  );
  if (classRegistrationButton) {
    const registrationStartDate = classRegistrationButton.getAttribute('data-registration-start');
    const registrationEndDate = classRegistrationButton.getAttribute('data-registration-end');
    const currentDate = Math.floor(Date.now() / 1000);

    if (currentDate < registrationStartDate || currentDate > registrationEndDate) {
      classRegistrationButton.classList.add('hidden');
    } else {
      classRegistrationButton.classList.remove('hidden');
    }
  }
};
